import React, {Component} from "react"
import {connect} from "react-redux"
import {push} from "react-router-redux"
import {injectIntl} from 'react-intl'
import {Button, Glyphicon, InputGroup, Modal} from "react-bootstrap"
import {DebounceInput} from "react-debounce-input"
import {queryUserInfo, setCurrentAccount} from '../../../dispatch'
import IBox from "../../../components/IBox"
import {effectiveApplications} from "../../../constants"
import {containsCogoland} from "../../AuthWrappers"
import {alertWarning} from "../../../util/AlertUtil"

function mapStateToProps(state, ownProps) {

  const user = state.user

  return {
    user
  }
}

const mapDispatchToProps = {
  queryUserInfo,
  setCurrentAccount,
  push
}

class EnterpriseAccountSelectionModal extends Component {

  constructor() {
    super()
    this.state = {
      order: 'asc',
      selectedAccountId: null,
      query: null
    }
  }

  componentWillMount() {
    this.props.queryUserInfo()
  }

  render() {

    const format = this.props.intl.formatMessage


    const filterAccount = (a) => {

      const query = this.state.query
      const contains = (s, q) => s ? s.toLowerCase().indexOf(q.toLowerCase()) > -1 : false
      return containsCogoland(a) && (_.isEmpty(query) ?
        true
        :
        contains(a.name, query))
    }

    let accounts = _.sortBy((this.props.user.employers || []).filter(filterAccount), (a) => {
      return a.name ? a.name.toLowerCase() : a.name
    })
    if (this.state.order === 'desc') accounts = accounts.reverse()

    const accountTemplate = (a) => {
      const licenses = a.licenses || []
      const selectedCss = a.id === this.state.selectedAccountId ? "gray-bg" : ""


      return (
        <div className={`row account-row custom-link ${selectedCss}`}
             onClick={() => {
               if(_.isEmpty(licenses)){
                 alertWarning("License Expired", "Please contact neeuro support for help.")
               } else
                 this.setState({selectedAccountId: a.id})
             }}
        >
          <div className={`col-xs-8 p-sm`}>
            <h4>{a.name}</h4>
          </div>

          <div className="col-xs-4 p-sm">
            {_.isEmpty(licenses)?
              <div className="text-center">
                <h4 style={{color: 'red'}}>License Expired</h4>
              </div>
              :licenses.map(l => {

              return (
                <div className="row m-b-sm">
                  <div className="col-xs-12 text-center">
                    {l ? `${l.usage}/${l.limit}` : 'N/A'}
                  </div>
                </div>)

            })}

          </div>
        </div>
      )
    }

    return (
      <Modal bsSize="lg"
             onEnter={() => {
               this.setState({query: null, selectedAccountId: null})
             }}
             show={this.props.show} onHide={this.props.onHide}>

        <Modal.Header closeButton>
          <h2>{format({id:'select.account'})}</h2>
        </Modal.Header>

        <Modal.Body className="gray-bg" style={{height: 480}}>

          <IBox>
            <InputGroup className="m-b-lg">
              <InputGroup.Addon>
                <Glyphicon glyph="search"/>
              </InputGroup.Addon>
              <DebounceInput
                placeholder={`${format({id: 'account.search'})} ...`}
                className="form-control input-sm"
                minLength={2}
                debounceTimeout={300}
                onChange={event => this.setState({query: event.target.value})}/>
            </InputGroup>

            <div className={`row`}>
              <div className={`col-xs-8 custom-link`} onClick={() => {
                const order = this.state.order
                if (order === 'asc') this.setState({order: 'desc'})
                else this.setState({order: 'asc'})
              }}>
                <div className="col-xs-3">
                  <h4>{format({id: 'account.name'})}</h4>
                </div>
                <div className="col-xs-9">
                  <i className={`m-t-xs fa fa-chevron-${this.state.order === 'asc' ? 'up' : 'down'}`}></i>
                </div>
              </div>
              <div className="col-xs-4 text-center">
                <h4>{format({id: 'account.select.users'})}</h4>
              </div>
            </div>

            {accounts.map((a) => accountTemplate(a))}
          </IBox>

        </Modal.Body>

        <Modal.Footer>

          <Button onClick={this.props.onHide}>
            {format({id: 'cancel'})}
          </Button>
          <div className={`btn btn-primary ${ this.state.selectedAccountId ? '' : 'disabled'}`}
               onClick={() => {
                 this.props.setCurrentAccount(this.state.selectedAccountId)
                 location.href = '/dashboard'
                 // location.href = '/enterprise/dashboard'
               }}>
            {format({id: 'ok'})}
          </div>

        </Modal.Footer>
      </Modal>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(EnterpriseAccountSelectionModal))



// WEBPACK FOOTER //
// ./src/routes/enterprise/components/EnterpriseAccountSelectionModal.js